import { render } from "./MissReasonView.vue?vue&type=template&id=a1cd60fa"
import script from "./MissReasonView.vue?vue&type=script&lang=js"
export * from "./MissReasonView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__